<template>
    <b-form-group
        id="input-group-5"
        :label="labelVal"
        label-for="label"
        :class="uploadFileCss ? 'upload-files' : ''"
    >
        <b-form-file
            id="profile-picture"
            ref="file"
            v-bind="$attrs"
            :placeholder="placeholderVal"
            drop-placeholder="Drop file here..."
            :accept="acceptFile"
            @change="uploadImage"
        ></b-form-file>
        <slot></slot>
    </b-form-group>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        type: {
            type: String,
            required: true,
        },
        labelVal: {
            type: String,
        },
        placeholderVal: {
            type: String,
            default: 'Choose file to upload',
        },
        acceptFile: {
            type: String,
            default:
                'image/jpeg, image/png, application/pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
        uploadFileCss: {
            type: Boolean,
            default: null,
        },
        importFileRun: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 10,
        },
        fileTypes: {
            type: Array,
            default: [
                'image/jpeg',
                'image/png',
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'text/csv',
            ],
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            uploadPercentage: 0,
            // fileTypes: ['image/jpeg', 'image/png', 'application/pdf'],
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['user', 'dataSegmentId', 'formBuilderList', 'loading']),
    }, // End of Component > mounted
    watch: {
        imagePreviewURL(value) {
            this.previewImage = value
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.$refs.file.reset()
    }, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        //Upload image
        uploadImage(e) {
            let self = this
            this.$store.commit('setFileLoading', true)
            const file = e.target.files[0]
            try {
                let formData = new FormData()
                if (file) {
                    const originalName = file.name
                    /*
                        Add the form data we need to submit
                    */

                    formData.append('type', this.type)
                    formData.append('file', file)

                    // console.log("file ", file.type)
                    // const extname = file.name.split('.').pop()
                    // console.log("ext ", extname)
                    if (this.formatBytes(file.size)) {
                        this.$toasted.show(
                            `File size must be less than ${this.size} MB`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )

                        return false
                    }

                    if (!this.fileTypes.includes(file.type)) {
                        this.$toasted.show(`Incorrect file format uploaded`, {
                            duration: 3000,
                            type: ['error'],
                        })
                        this.$store.commit('setFileLoading', false)
                        this.$emit('stop-update', false)
                        return false
                    } else {
                        this.$emit('stop-update', true)
                        this.fileUploadApi(formData, originalName)
                    }
                    this.$store.commit('setFileLoading', false)
                }
            } catch (error) {
                // console.log(error)
                //this.$store.commit('setError', error.response.data.message)
            }
            this.$store.commit('setFileLoading', false)
        }, // End of upload image function

        formatBytes(bytes) {
            return (
                (bytes / 1048576).toFixed(3) >
                (typeof this.size != 'undefined' ? this.size : 20)
            )
        }, // End of formatBytes function

        async fileUploadApi(formData, originalName) {
            let response = await axios.post(apiUrl + 'files/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem(
                        'vueauth_token'
                    )}`,
                },

                onUploadProgress: function (progressEvent) {
                    this.uploadPercentage = parseInt(
                        Math.round(
                            (progressEvent.loaded / progressEvent.total) * 100
                        )
                    )
                    if (this.uploadPercentage < 98 && this.importFileRun) {
                        self.$emit('show-progress', this.uploadPercentage)
                    }
                },
            })
            response.data.data.originalName = originalName
            this.$emit('set-value', response.data.data)
            if (this.importFileRun) {
                let filename = response.data.data.fileName
                let obj = {}
                obj.fileName = filename
                obj.dataSegmentId = this.dataSegmentId
                await axios.post(apiUrl + 'screening-data/import/', obj, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                })
                this.$emit('show-progress', 100)
            }
            this.$toasted.show(response.data.message, {
                duration: 2000,
                type: ['success'],
            })
        },
    },
} // End of export default
</script>
